// extracted by mini-css-extract-plugin
export default {"wrapper":"SubmitCalculations_wrapper__7Ou+r"};